// Геометрия drop-зон: общая для HTML5 dragover (VariantColumn) и тач-фолбэка (useTouchDrag),
// чтобы индекс вставки считался одинаково в обоих путях.
import { DROP_INDEX_ATTR, DROP_REMOVE_ATTR, DROP_VARIANT_ATTR } from './constants';

/**
 * Индекс вставки внутри контейнера варианта по вертикальной позиции курсора —
 * сравнивает clientY с вертикальным центром каждой карточки (data-drop-index).
 * Возвращает длину списка, если курсор ниже центра последней карточки (вставка в конец).
 */
export function computeInsertIndex(container: Element, clientY: number): number {
  const cards = Array.from(container.querySelectorAll<HTMLElement>(`[${DROP_INDEX_ATTR}]`));
  for (const card of cards) {
    const rect = card.getBoundingClientRect();
    const mid = rect.top + rect.height / 2;
    if (clientY < mid) {
      const idx = Number(card.getAttribute(DROP_INDEX_ATTR));
      return Number.isNaN(idx) ? 0 : idx;
    }
  }
  return cards.length;
}

export interface VariantDropZone {
  variantId: string;
  container: HTMLElement;
}

/** Находит контейнер-вариант по точке экрана (для тач-фолбэка, через elementFromPoint). */
export function locateVariantDropZone(clientX: number, clientY: number): VariantDropZone | null {
  const el = document.elementFromPoint(clientX, clientY);
  if (!el) return null;
  const container = el.closest<HTMLElement>(`[${DROP_VARIANT_ATTR}]`);
  if (!container) return null;
  const variantId = container.getAttribute(DROP_VARIANT_ATTR);
  if (!variantId) return null;
  return { variantId, container };
}

/** Есть ли под точкой экрана явная зона «убрать из варианта» / фон рабочей области. */
export function locateRemoveZone(clientX: number, clientY: number): boolean {
  const el = document.elementFromPoint(clientX, clientY);
  return !!el?.closest(`[${DROP_REMOVE_ATTR}]`);
}
